import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import { circularProgressSizeProps } from '@opengov/capital-mui-theme';
import React from 'react';
import locale from '../customReports-locale.json';
import { useFetchNamedRangeMarkup } from '../hooks/useFetchNamedRangeMarkup';
import { styles } from './CustomReportPreview.styles';
import './CustomReportPreview.scss';

type Props = {
  publicationId: string;
  spreadsheetId: string;
  selectedNamedRangeId: string;
};

export function CustomReportPreview({ publicationId, spreadsheetId, selectedNamedRangeId }: Props) {
  const {
    data: markupData,
    isLoading: isLoadingHtmlPreview,
    isFetching: isFetchingHtmlPreview
  } = useFetchNamedRangeMarkup({
    publicationId,
    spreadsheetId,
    namedRangeId: selectedNamedRangeId,
    enabled: true
  });
  const isLoadingHtml = isLoadingHtmlPreview && isFetchingHtmlPreview;

  if (isLoadingHtml) {
    return (
      <Box sx={styles.previewLoadingContainer} data-test="edit-report-modal-preview-loading">
        <CircularProgress {...circularProgressSizeProps.medium} />
      </Box>
    );
  }

  if (markupData?.html) {
    return (
      <Box
        sx={styles.previewContent}
        dangerouslySetInnerHTML={{ __html: markupData.html }}
        data-test="edit-report-modal-preview-content"
      />
    );
  }

  return (
    <Typography variant="body2" data-test="edit-report-modal-preview-placeholder">
      {locale.customReportPreview.reportPreviewPlaceholder}
    </Typography>
  );
}
